<template>
  <div class="gw-cards">
    <div v-if="loading" class="rmr-data-table__state">
      <v-progress-circular indeterminate color="primary" size="32" />
      <div class="rmr-data-table__state-text">Chargement des sources…</div>
    </div>

    <div v-else-if="items.length === 0" class="rmr-data-table__state">
      <div class="rmr-data-table__state-title">Aucun résultat</div>
      <div v-if="isVideo" class="rmr-data-table__state-text">
        Élargissez la période, ou vérifiez qu'au moins une config de ce site
        est déclarée en vidéo.
      </div>
      <div v-else class="rmr-data-table__state-text">
        Élargissez la période, baissez le score minimum ou décochez
        « Masquer les déjà traités ».
      </div>
    </div>

    <template v-else>
      <div class="gw-cards__grid">
        <source-card
          v-for="item in items"
          :key="item.id"
          :item="item"
          :selected="isSelected(item.id)"
          :expanded="isExpanded(item.id)"
          @toggle-select="$emit('toggle-select', $event)"
          @toggle-expand="$emit('toggle-expand', $event)"
          @open-video="$emit('open-video', $event)"
        />
      </div>

      <!-- The mock had no pagination; the list is server-paginated, so it needs
           its own footer here. -->
      <div v-if="pageCount > 1" class="gw-cards__footer">
        <span class="gw-cards__range">{{ rangeLabel }}</span>
        <v-pagination
          :value="options.page"
          :length="pageCount"
          :total-visible="7"
          color="primary"
          @input="$emit('update:page', $event)"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";

import SourceCard from "./SourceCard.vue";

export default {
  name: "SourcesCardsView",
  components: { SourceCard },
  props: {
    items: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    options: { type: Object, required: true },
    total: { type: Number, default: 0 },
    isSelected: { type: Function, required: true },
    isExpanded: { type: Function, required: true },
    isVideo: { type: Boolean, default: false },
  },
  setup(props) {
    const pageCount = computed(() =>
      Math.max(1, Math.ceil(props.total / props.options.itemsPerPage))
    );

    const rangeLabel = computed(() => {
      const start = (props.options.page - 1) * props.options.itemsPerPage + 1;
      const end = Math.min(props.options.page * props.options.itemsPerPage, props.total);
      return `${start}–${end} sur ${props.total}`;
    });

    return { pageCount, rangeLabel };
  },
};
</script>

<style lang="scss" scoped>
.gw-cards__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(272px, 1fr));
  gap: 16px;
  padding: 8px 0 4px;
}

.gw-cards__footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  padding-top: 12px;
  margin-top: 12px;
  border-top: 1px solid $rmr-border;
}

.gw-cards__range {
  font-size: 12.5px;
  color: $rmr-text-subtle;
}
</style>
